export default __webpack_public_path__ + "2008539b8e828cfa2be2754cb64a2a52.png";